import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import '@common/config' // APP的所有公共配置放在这里
import { i18nInstance } from '@utils'
import '@css/index.scss' // 全局css样式
import App from './App'
import init from 'common/init' // 初始化
import authHandle from 'common/init/authHandle' // 初始化授权
import { trace, boJudge, cookie } from '@dt/fe-utils'
import authAgreememtInit from '@common/init/authAgreememtInit'
import { WxpayGoldPlanController } from '@ctrls/index'

(async function () {
  // dtfe-utils config
  (window as any).__FE_UTILS_CONFIG = {
    priceHasZero: false
  }
  if (ENV.env === 'pro') {
    trace.init({
      pid: ENV.ARMS.pid, // 应用id
      imgUrl: ENV.ARMS.imgUrl,
      release: window.buildinfo.buildDate.substr(2, 14).replace(/[-|:]/g, '').replace(' ', '-'),
      environment: cookie.getCookie('handtop_channel') === 'stage' ? 'gray' : 'prod'
    })
  }
  // 先加载i18n
  await i18nInstance
  const homePageData = await window.preHomepage
  /**
   * bo控制 用于功能的bo/品牌/门店判断
   * boJudge.init 初始化
   * boJudge.checkKey('运营平台具体key') 获取是否有权限
   */
  window.boJudge = boJudge
  if (!WxpayGoldPlanController.isOpen()) {
    await boJudge.init({
      app: 'handtop',
      bo: window.bo,
      brandId: Config.BRANDID,
      storeId: Config.STOREID,
    })
  }
  const memberData = await window.preMember
  await window.preMini // 从非微信/支付宝环境进入的h5入口，需要先获取是否绑定小程序的标记，以便跳转到提示跳转微信/支付宝的中转页
  let authRes = await authHandle(memberData)
  if (!authRes) return
  await authAgreememtInit(memberData)
  await init(homePageData, memberData, authRes)
  // render APP
  ReactDOM.render(<App />, document.getElementById('root'))
})()

serviceWorker.unregister()
// serviceWorker.register()
